import { Helmet } from "react-helmet-async";
import { NOINDEX, SITE_URL } from "../../lib/site";
import { eur } from "../../lib/offer";
import SEO from "../../seo.json";
import offer from "../../generated/offer-config.json";

export const OG_DEFAULT = { image: "/og/novasoft-share-v2.jpg", imageAlt: "NovaSoft — Sites, IA & automatisation pour faire grandir votre business" };
const fill = (s) => s.replace(/\{(\w+)\}/g, (_, k) => (typeof offer.prices[k] === "number" ? eur(offer.prices[k]) : offer.prices[k]));

export const Seo = ({ path }) => {
  const m = { ...OG_DEFAULT, ...SEO[path] };
  const title = fill(m.title);
  const description = fill(m.description);
  const ogTitle = m.ogTitle ? fill(m.ogTitle) : title;
  const ogDesc = m.ogDescription ? fill(m.ogDescription) : description;
  const url = `${SITE_URL}${path}`;
  const img = `${SITE_URL}${m.image}`;
  return (
    <Helmet>
      <html lang="fr" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {NOINDEX && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content="NovaSoft" />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDesc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:image:secure_url" content={img} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={m.imageAlt} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle} />
      <meta name="twitter:description" content={ogDesc} />
      <meta name="twitter:image" content={img} />
      <meta name="twitter:image:alt" content={m.imageAlt} />
    </Helmet>
  );
};
